import { Form, InputGroup, Table, FormCheck } from '@themesberg/react-bootstrap'
import React from 'react'
import { commonDateFormat } from '../../../../utils/dateFormatter'
import { BET_PREFERENCE } from '../constants'

const BonusDetailModal = ({
  bonusAmount,
  bonusDetail,
  setBonusAmount,
  user,
  autoActivateBonus,
  setAutoActivateBonus,
  betPreference,
  setBetPreference,
  showBetPreference
}) => {

  return (
    <div className='d-flex flex-column' style={{ maxHeight: '60vh' }}>
      <div className='flex-grow-1 overflow-auto'>
        <Table striped className='text-start'>
          {bonusDetail &&
            <tbody>
              <tr>
                <td>Promotion Title</td>
                <td>{bonusDetail?.promotionTitle?.EN}</td>
              </tr>
              <tr>
                <td>Bonus Type</td>
                <td>{bonusDetail?.bonusType}</td>
              </tr>
              {['match', 'manual', 'deposit', 'wagering'].includes(bonusDetail?.bonusType) &&
                <tr>
                  <td>Bonus Percentage</td>
                  <td>{bonusDetail?.depositBonusPercent}%</td>
                </tr>}
              {['match', 'deposit', 'wagering'].includes(bonusDetail?.bonusType) &&
                <tr>
                  <td>Sticky</td>
                  <td>{bonusDetail?.isSticky ? 'Yes' : 'No'}</td>
                </tr>}
              {['match', 'manual', 'deposit', 'wagering'].includes(bonusDetail?.bonusType) &&
                <tr>
                  <td>Bonus Bet Only</td>
                  <td>{bonusDetail?.bonusBetOnly ? 'Yes' : 'No'}</td>
                </tr>}
              {bonusDetail?.bonusType === 'freespins' &&
                <tr>
                  <td>Quantity</td>
                  <td>{bonusDetail?.quantity}</td>
                </tr>}
              {bonusDetail?.validFrom && bonusDetail?.bonusType !== 'winBoost' &&
                <tr>
                  <td>Valid From</td>
                  <td>{commonDateFormat(bonusDetail?.validFrom)}</td>
                </tr>}
              {bonusDetail?.validTo && bonusDetail?.bonusType !== 'winBoost' &&
                <tr>
                  <td>Valid To</td>
                  <td>{commonDateFormat(bonusDetail?.validTo)}</td>
                </tr>}
              <tr>
                <td>Days To Clear</td>
                <td>{bonusDetail?.daysToClear}</td>
              </tr>
              {(bonusDetail?.wageringMultiplier !== 0 && bonusDetail?.bonusType !== 'manual') &&
                <tr>
                  <td>Wagering Type</td>
                  <td>{bonusDetail?.wageringRequirementType}</td>
                </tr>}
              {(bonusDetail?.wageringMultiplier !== 0) &&
                <tr>
                  <td>Wagering Multiplier</td>
                  <td>{bonusDetail?.wageringMultiplier}</td>
                </tr>}
              {bonusDetail?.bonusType === 'winBoost' &&
                <tr>
                  <td>Time Period</td>
                  <td>{parseInt(bonusDetail?.other?.timePeriod) === 1 ? 'Daily' : (parseInt(bonusDetail?.other?.timePeriod) === 7 ? 'Weekly' : 'Monthly')}</td>
                </tr>}
            </tbody>}
        </Table>
      </div>
      <div className='pl-1 mt-2'>
        {bonusDetail && (
          <div className='d-flex justify-content-start align-items-center my-2'>
            <Form.Check
              className='form-label'
              type='checkbox'
              label='Auto Activate'
              checked={autoActivateBonus}
              onClick={() => setAutoActivateBonus(!autoActivateBonus)}
            />
          </div>
        )}

        {showBetPreference && <div className='d-flex align-self-center mb-4'>
          <div>
            <Form.Label className='me-2'>Bet Preference</Form.Label>
            <FormCheck.Input
              type='radio'
              className='mx-2 cursor-pointer'
              checked={betPreference === BET_PREFERENCE.BONUS}
              onChange={() => setBetPreference(BET_PREFERENCE.BONUS)}
            />
            <FormCheck.Label className='me-3' htmlFor='Bonus' style={{ fontSize: '12px' }}>Bonus</FormCheck.Label>

            <FormCheck.Input
              type='radio'
              className='mx-2 cursor-pointer'
              checked={betPreference === BET_PREFERENCE.CASH}
              onChange={() => setBetPreference(BET_PREFERENCE.CASH)}
            />
            <FormCheck.Label className='me-3' htmlFor='Cash' style={{ fontSize: '12px' }}>Cash</FormCheck.Label>
          </div>
        </div>}

        {bonusDetail && ['match', 'wagering', 'winBoost', 'manual'].includes(bonusDetail?.bonusType) && (
          <div className='d-flex justify-content-start align-items-center'>
            <Form.Label className='mb-0' style={{ marginRight: '24px' }}>Amount <small>(optional)</small></Form.Label>
            <InputGroup className='w-50'>
              <InputGroup.Text>
                {user?.currencyCode}
              </InputGroup.Text>

              <Form.Control
                type='number'
                min={0}
                name='amount'
                className='w-50'
                placeholder='Enter Amount'
                value={bonusAmount || ''}
                onChange={(e) => setBonusAmount(e?.target?.value)}
              />
            </InputGroup>
          </div>
        )}
      </div>
    </div>
  )
}

export default BonusDetailModal
